import * as React from 'react';
import ModalContext from './ModalContext';
import ReactModal from 'react-modal';
import { styled } from 'linaria/react';
const Cover = /*#__PURE__*/styled('div')({
  name: "Cover",
  class: "cvu0uh1"
});
Cover.displayName = 'Cover';

const ModalRoot = () => {
  const {
    modals
  } = React.useContext(ModalContext);
  return React.createElement(React.Fragment, null, modals.map(modalProps => React.createElement(Modal, Object.assign({
    key: modalProps.modalId
  }, modalProps))));
};

const Modal = ({
  modalComponent,
  isOpen,
  modalType,
  hideTarget,
  props
}) => {
  /** Do not render anything if there is no active modal */
  if (!isOpen) return null;
  const Component = modalComponent;

  if (Component && isOpen && modalType === 'modal') {
    /** A modal has been requested, from somewhere in the app  */
    return React.createElement(ReactModal, Object.assign({
      style: {
        overlay: {
          zIndex: 999
        }
      },
      className: props.modalStyles
    }, props.modalProps, {
      /** isOpen should always be true here, since this is only rendered when a modal is requested */
      isOpen: true,

      /**
       * react-modal requires an onRequestClose prop that takes a func to call when the modal is closed
       * We use this to make sure the context is updated
       */
      onRequestClose: hideTarget
    }), React.createElement(Component, Object.assign({
      hideTarget: hideTarget
    }, props)));
  }

  if (isOpen && props.showCover) {
    const coverStyles = props === null || props === void 0 ? void 0 : props.coverStyles;
    /** Inject a clickable 'cover' behind flyouts */

    return React.createElement(Cover, {
      onClick: hideTarget,
      style: coverStyles
    });
  }

  return null;
};

export default ModalRoot;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Modal/ModalRoot.linaria.css");